class BannerSlider {
	constructor() {
		this.slider = document.querySelector('.bannerSwiper');
		this.cursor = document.querySelector('#circularcursor');
		this.header = document.querySelector('.header-main');

		if (this.slider) {
			this.init();
		}
	}

	init() {
		this.swiper = new Swiper(this.slider, {
			loop: true,
			speed: 1000,
			slidesPerView: 'auto',
			autoplay: {
				delay: 3000,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},

			breakpoints: {
				374: {
					spaceBetween: 20,
				}
			},
			on: {
				"slideChangeTransitionEnd": (swiper) => {
					let slides = this.slider.querySelectorAll('.swiper-slide:not(.swiper-slide-active)');
					slides.forEach((slide) => {
						slide.classList.remove('slide-appeared');
					});
					let current = this.slider.querySelector('.swiper-slide-active');
					current.classList.add('slide-appeared');
				}
			},
		});

		this.cursorMove();
	}

	cursorMove() {

		this.slider.addEventListener('mousemove', (e) => {
			let rect = this.slider.getBoundingClientRect();
			let relX = (e.clientX - rect.left) - this.cursor.offsetWidth / 2;
			let relY = (e.clientY - rect.top) - this.cursor.offsetHeight / 2;

			gsap.to(this.cursor, {
				duration: 0.2,
				ease: "none",
				opacity: 1,
				scale: 1,
				x: relX,
				y: relY
			});
		});

		this.slider.addEventListener('mouseleave', () => {
			gsap.to(this.cursor, {
				duration: 0.2,
				scale: 0,
				opacity: 0,
			});
		});

		this.slider.addEventListener('mouseenter', () => {
			gsap.to(this.cursor, {
				duration: 0.2,
				scale: 1,
				opacity: 1,
			});
		});
	}
}
